/**
 * 全量枚举code值
 * 该字段会自动从接口读取
 * @type {{}}
 */
export const ENUM_CODE = new Map()

/**
 * 搜索条件集合
 * @type {{}}
 */
export const ENUM_PARAMS_CODE = new Map()

// 项目-项目类型
export const PROJECT_TYPE = {
  1004501: '项目',
  1004502: '分期',
  1004503: '楼栋',
  1005501: '公区',
  1005502: '非工区'
}

// 组织架构-组织架构类型
export const ORGAN_TYPE = {
  1: '集团',
  2: '公司',
  3: '部门',
  4: '岗位'
}
